import styled from 'styled-components/macro'
import { CircularProgress } from '@mui/material'

const Container = styled.div`
    display: flex;
    justify-content: center;

    padding: 5em;
`

export const TestId = 'Components/GenericLoading'

export function GenericLoading() {
    return (
        <Container id={TestId}>
            <CircularProgress />
        </Container>
    )
}
